// Where ui-web's views sit when Books draws them in Blueprint (the Overview's who owes what): its
// actions run through the office's client as the person, and "open" goes to the Books part that holds
// it. A view never decides anything itself; a request that waits for a person comes back as waiting.
import { RpcError } from '@flowology/client';
import type { Host, OpenTarget } from '@flowology/ui-web';
import { client } from '../api.ts';
import type { BooksPart } from './props.ts';

/** The Books part each place a view can open is in; one that isn't in Books opens nothing here. */
export function partFor(target: OpenTarget): BooksPart | null {
  if (target.kind === 'owed') return 'receivables';
  if (target.kind === 'approvals') return 'approvals';
  if (target.kind === 'numbers') return 'overview';
  return null;
}

export function officeHost(go: (p: BooksPart) => void): Host {
  return {
    surface: 'office',
    theme: 'light',
    open: (target) => {
      const part = partFor(target);
      if (part) go(part);
    },
    callTool: async (name, args) => {
      try {
        return { ok: true, result: await client.call(name, args) };
      } catch (e) {
        if (e instanceof RpcError && e.code === 'pending_approval')
          return { ok: false, waiting: true, message: e.message };
        return {
          ok: false,
          code: e instanceof RpcError ? e.code : 'failed',
          message: e instanceof RpcError ? e.message : 'That did not work. Try again.',
        };
      }
    },
  };
}
